<template>
    <div class="modal share">
        <div class="modal-title">
            Share Replay
        </div>
        <div class="modal-footer">
            <div class="link-preview">
                <input
                    class="link-url"
                    :value="linkUrl"
                    @input="onEditLink"
                    ref="link-url"
                />
                <span class="link" @click="onCopyUrl">
                    COPY
                </span>
            </div>
            <div class="start-at-wrapper" :class="{ ['checked']: startShareAt }">
                <div class="start-at-content">
                    <label class="pseudo-checkbox-wrapper">
                        <input
                            class="pseudo-checkbox-input"
                            name="start_replay_at"
                            v-model="startShareAt"
                            @input="onToggleReplayStartAt"
                            type="checkbox"
                        />
                        <span class="psuedo-checkbox">
                            <fa-icon icon="check" class="checkmark" />
                        </span>
                    </label>
                    <span
                        class="start-at-label"
                        @click="onToggleReplayStartAt"
                    >
                    Start at move
                    </span>
                    <input
                        class="start-at-input"
                        name="startShareAtMove"
                        v-model="startShareAtMove"
                        @input="onEditStartAt"
                        :disabled="!startShareAt"
                    />
                </div>
            </div>
        </div>
        <div class="close-btn" @click="onCloseModal">
            <fa-icon class="icon" icon="times" />
        </div>
    </div>
</template>

<script>

export default {
    name: 'ShareModal',
    props: ['currentMove', 'url', 'totalMoves'],
    created() {
        this.startShareAtMove = this.currentMove;
        this.linkUrl = `${this.url}${this.startAtMoveQuery}`;
    },
    watch: {
        startShareAtMove(currentValue) {
            if (currentValue > this.totalMoves) {
                this.startShareAtMove = this.totalMoves;
            }

            if (currentValue !== '' && isNaN(currentValue)) {
                this.startShareAtMove = 1;
            }
        },
        startShareAt(currentValue, prevValue) {
            if (!prevValue && currentValue) {
                this.linkUrl = `${this.url}${this.startAtMoveQuery}`;
            } else if (prevValue && !currentValue) {
                this.linkUrl = `${this.url}`;
            }
        },
    },
    data() {
        return {
            startShareAtMove: 1,
            startShareAt: false,
            linkUrl: this.url,
        };
    },
    computed: {
        startAtMoveQuery() {
            return this.startShareAt ? `?move=${this.resolveStartShareAt(this.startShareAtMove)}` : '';
        },
        linkRef() {
            return this.$refs['link-url'];
        },
    },
    methods: {
        onToggleReplayStartAt() {
            this.startShareAt = !this.startShareAt;
        },
        onCloseModal() {
            this.$store.dispatch('closeModal', 'share');
        },
        async onCopyUrl() {
            this.linkRef.select();
            this.linkRef.setSelectionRange(0, 99999);
            document.execCommand('copy');

            this.$notify({
                group: 'app',
                title: 'Success',
                type: 'success',
                text: 'Link copied to clipboard',
            });
        },
        onEditLink() {
            this.linkRef.value = `${this.url}${this.startAtMoveQuery}`;
        },
        onEditStartAt() {
            this.linkUrl = `${this.url}${this.startAtMoveQuery}`;
        },
        resolveStartShareAt(value) {
            const normalisedValue = parseInt(String(value).replace(/[^0-9]/, ''), 10);

            if (normalisedValue < 1 || isNaN(normalisedValue)) {
                return 1;
            } else if (normalisedValue > this.totalMoves) {
                return this.totalMoves;
            }

            return normalisedValue;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .modal {

        &.share {

            .link-preview {
                background: $extra-light-gray;
                display: flex;
                justify-content: space-between;
                min-width: 600px;
                padding: 15px 20px;
                text-align: left;

                .link-url {
                    background: transparent;
                    border: none;
                    font-size: 1em;
                    width: 100%;
                }

                .link {
                    font-weight: bold;
                    margin-left: 15px;
                }
            }

            .start-at-wrapper {
                border-top: 1px solid $light-gray;
                font-size: 1em;
                margin-top: 20px;
                padding-top: 20px;
                position: relative;
                text-align: left;
                user-select: none;

                .start-at-input {
                    background: none;
                    border-bottom: 1px solid transparent;
                    border: none;
                    color: $medium-dark-gray;
                    font-size: 1em;
                    margin-left: 5px;
                    padding: 5px;
                    vertical-align: middle;
                    width: 35px;
                }

                .start-at-content {
                    min-height: 29px;
                }

                &.checked {

                    .psuedo-checkbox {
                        background: $dark-blue;

                        .checkmark {
                            color: white;
                            display: inline-block;
                        }
                    }

                    .start-at-input {
                        border-bottom: 1px solid $dark-blue;
                        color: $dark-blue;
                    }
                }
            }

            .close-btn {
                cursor: pointer;
                position: absolute;
                right: 20px;
                top: 15px;

                .icon {
                    font-size: 1.1em;
                }
            }
        }
    }

</style>
